import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { AdminLayoutComponent } from './admin-layout.component';
import { ProfilMenuComponent } from '../../components/profil-menu/profil-menu.component';

@NgModule({
  declarations: [AdminLayoutComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    ProfilMenuComponent,
  ],
  exports: [AdminLayoutComponent],
})
export class AdminLayoutModule {}
